var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolTypograohyLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76367 27C9.76367 17.0589 17.8225 9 27.7637 9H63.7637C73.7048 9 81.7637 17.0589 81.7637 27V63C81.7637 72.9411 73.7048 81 63.7637 81H27.7637C17.8225 81 9.76367 72.9411 9.76367 63V27Z",
    fill: "url(#paint0_linear_219_4779)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0182 58.4819C59.8182 58.4819 62.4365 56.9547 63.5638 54.5909H63.6364V56.991C63.6364 57.9001 64.2546 58.5 65.1091 58.5C65.982 58.5 66.6001 57.9001 66.6001 56.9182V44.791C66.6001 40.8273 63.691 38.2637 59.0727 38.2637C55.6546 38.2637 52.8001 39.7727 51.7638 42.1182C51.5636 42.5728 51.4182 43.0091 51.4182 43.3909C51.4182 44.191 52.0183 44.7182 52.8001 44.7182C53.3636 44.7182 53.8001 44.5001 54.0728 43.991C55.091 41.8819 56.6364 40.9 59.0001 40.9C61.8364 40.9 63.5273 42.4819 63.5273 45.0273V46.591L57.6546 46.9182C53.0546 47.1728 50.491 49.3001 50.491 52.6818C50.491 56.1547 53.1637 58.4819 57.0182 58.4819ZM57.7637 55.9547C55.3092 55.9547 53.6364 54.6092 53.6364 52.6092C53.6364 50.6818 55.1819 49.391 58.0364 49.2091L63.5273 48.8637V50.7909C63.5273 53.682 60.9638 55.9547 57.7637 55.9547ZM26.4545 58.3546C27.4182 58.3546 27.8909 57.991 28.2363 56.9727L30.5818 50.5547H41.3091L43.6546 56.9727C44 57.991 44.4727 58.3546 45.4183 58.3546C46.3818 58.3546 47.0001 57.7728 47.0001 56.8636C47.0001 56.5546 46.9456 56.2638 46.8 55.8819L38.2728 33.1727C37.8546 32.0636 37.1091 31.5 35.9455 31.5C34.8182 31.5 34.0546 32.0455 33.6546 33.1546L25.1273 55.9002C24.9818 56.2818 24.9273 56.5728 24.9273 56.8819C24.9273 57.791 25.5091 58.3546 26.4545 58.3546ZM31.4727 47.791L35.8909 35.5546H35.9818L40.4 47.791H31.4727Z",
    fill: "url(#paint1_linear_219_4779)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4779",
    x: 0.763672,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_219_4779"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4779",
    x1: 45.7637,
    y1: 9,
    x2: 45.7637,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4779",
    x1: 45.7642,
    y1: 31.5,
    x2: 45.7642,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolTypograohyLong);
export default __webpack_public_path__ + "static/media/symbol-typograohy-long.24cc4b684c7f51b0dcd67f6071450f8d.svg";
export { ForwardRef as ReactComponent };